module.exports = __webpack_public_path__ + "img/menuIcon.472190c4.svg";